var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSafemcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 80,
    viewBox: "0 0 224 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-gradient",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A78BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6366F1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5,0 L 10,5 L 5,10 L 0,5 Z",
    fill: "url(#star-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-icon-group",
    transform: "translate(10,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4, 4) scale(1.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27.9883 51.2969 C 28.3633 51.2969 28.9492 51.1562 29.5586 50.8516 C 42.6602 43.4688 47.1836 40.3750 47.1836 31.9609 L 47.1836 14.2891 C 47.1836 11.8750 46.1289 11.1016 44.1836 10.2813 C 41.4414 9.1562 32.6524 5.9922 29.9336 5.0313 C 29.3008 4.8438 28.6680 4.7031 27.9883 4.7031 C 27.3320 4.7031 26.6992 4.8438 26.0664 5.0313 C 23.3476 6.0156 14.5586 9.1797 11.8164 10.2813 C 9.8711 11.0781 8.8164 11.8750 8.8164 14.2891 L 8.8164 31.9609 C 8.8164 40.3750 13.3633 43.4453 26.4414 50.8516 C 27.0508 51.1562 27.6133 51.2969 27.9883 51.2969 Z M 19.7617 35.7344 L 19.7617 26.6406 C 19.7617 25.1172 20.3476 24.3203 21.5898 24.1328 L 21.5898 21.3203 C 21.5898 17.0078 24.1914 14.1016 27.9883 14.1016 C 31.8086 14.1016 34.3867 17.0078 34.3867 21.3203 L 34.3867 24.1094 C 35.6524 24.2969 36.2383 25.0938 36.2383 26.6406 L 36.2383 35.7344 C 36.2383 37.4922 35.4649 38.3125 33.8242 38.3125 L 22.1524 38.3125 C 20.5351 38.3125 19.7617 37.4922 19.7617 35.7344 Z M 24.0508 24.0860 L 31.9492 24.0625 L 31.9492 21.0625 C 31.9492 18.2969 30.3789 16.4687 27.9883 16.4687 C 25.6211 16.4687 24.0508 18.2969 24.0508 21.0625 Z",
    fill: "#4F46E5"
  })), /*#__PURE__*/React.createElement("use", {
    href: "#star-path",
    transform: "translate(2, 2) scale(1.5) rotate(-15, 5, 5)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#star-path",
    transform: "translate(50, 48) scale(1.5) rotate(10, 5, 5)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("use", {
    href: "#star-path",
    transform: "translate(5, 50) scale(1.5) rotate(15, 5, 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 26,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    fill: "#292B3D"
  }, "SafeMCC"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 48,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 15,
    fill: "#6B7280"
  }, "by ", /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 600,
    fill: "#4F46E5"
  }, "s360"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSafemcc);
export default __webpack_public_path__ + "static/media/logo-safemcc.df49e7d9bed79d68d087d7a09cff045c.svg";
export { ForwardRef as ReactComponent };